import PropTypes from 'prop-types';
import MessageType from '../../../enums/MessageType';
import Message from '../../components/ui/Message/Message';

export default function ValidationMessage(props) {
  if (!props.errorText) return null;
  
  return (
    <Message type={MessageType.ERROR} inline associatedFieldId={props.associatedFieldId}>
      {props.errorText}
    </Message>
  );
}

ValidationMessage.propTypes = {
  associatedFieldId: PropTypes.string,
  errorText: PropTypes.string.isRequired,
};
